export default __webpack_public_path__ + "static/media/logo-Global-Net2.bceb2c87.png";